var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex my-4"},[_c('div',[(_vm.rowCount && _vm.odataCount)?_c('span',[_vm._v("Gezeigt werden "+_vm._s(_vm.rowCount)+" von "+_vm._s(_vm.odataCount)+" Zeilen")]):_vm._e(),(_vm.markedCount && _vm.markedCount > 0)?_c('span',[_vm._v(" ("+_vm._s(_vm.markedCount)+" ausgewählt)")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }